<template>
  <div>
    <van-sticky>
      <van-nav-bar :title="channelFansData.title" left-text="返回" left-arrow @click-left="handleBack">
        <template #right>
          <a @click="handleExport">导出</a>
        </template>
      </van-nav-bar>
      <van-search
        v-model="queryParam.friendWhatsId"
        placeholder="请输入联系人客服号"
        show-action
        @search="reloadTable(true)"
      >
        <template #action>
          <div @click="reloadTable(true)">查询</div>
        </template>
      </van-search>
    </van-sticky>
    <!-- 列表 -->
    <van-pull-refresh v-model="loading" @refresh="resetSearchForm">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="reloadTable">
        <van-card v-for="item in dataSource" :key="item.id">
          <template #title>
            <div>联系人 {{ item.friendWhatsId }} <span v-if="item.nickname">({{ item.nickname }})</span></div>
          </template>
          <template #desc>
            <div>客服号 {{ item.whatsId }}</div>
          </template>
          <template #thumb>
            <a-avatar shape="square" icon="user" :src="item.avatar" :size="70" />
          </template>
          <template #price>
            {{ item.countryCode }}
          </template>
          <template #num>
            {{ item.createTime }}
          </template>
        </van-card>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ListPageMixin } from '@/mixins'
import { exportFiles } from '@/utils/util'

export default {
  mixins: [ListPageMixin],
  props: {
    channelFansData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  created() {
    this.getPage = this.channelFansData.getPage
  },
  methods: {
    handleBack() {
      this.$emit('goBack')
    },
    handleExport() {
      this.exportLoading = true
      exportFiles({
        request: this.channelFansData.exportFunction,
        queryParam: this.queryParam,
        callback: () => {
          this.exportLoading = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
